/**
 * Error type for the Insights ("For You") data layer. The active-alerts loader
 * and status mutator surface failures as this so the UI can branch on a single
 * error type and show a consistent message.
 */
export class InsightsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InsightsError';
  }
}
